import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";

import {
    breakpoints,
    SectionDark,
    A,
    Grid,
    Col,
    fonts,
    colors,
    GrayButton,
    MessageBanner,
    FormInput,
    P,
    easingSeconds
} from "../shared";

import NpInlineLogo from "../icons/NpInlineLogo";

// newsletter subscription
export const NewsletterSubscriptionSuccessMessage = styled(MessageBanner)`
    width: 20.125rem;

    @media (max-width: ${breakpoints.md}rem) {
        width: 100%;
    }
`;

export const NewsletterSubscriptionSubmitBtn = styled(GrayButton)`
    width: 5.9375rem;

    @media (max-width: ${breakpoints.md}rem) {
        width: 100%;
    }
`;

export const NewsletterSubscriptionInput = styled(FormInput)`
    width: 13.375rem;

    @media (max-width: ${breakpoints.md}rem) {
        width: 100%;
    }
`;

export const NewsletterSubscriptionForm = styled.form`
    display: flex;

    ${NewsletterSubscriptionInput} {
        margin-right: 0.8125rem;

        @media (max-width: ${breakpoints.md}rem) {
            margin-right: 0;
            margin-bottom: 1.3rem;
        }
    }

    @media (max-width: ${breakpoints.md}rem) {
        display: block;
    }
`;

export const NewsletterSubscriptionHeading = styled(P)`
    font-size: 1.125rem;
`;

export const NewsletterSubscription = styled.div`
    @media (max-width: ${breakpoints.md}rem) {
        width: 100%;
        margin-top: 3rem;
        margin-bottom: 3rem;
    }

    ${NewsletterSubscriptionHeading} {
        margin-top: 0;
        margin-bottom: 1.25rem;
    }
`;

// social media
export const SocialsItem = styled.li`
    width: 2.125rem;
    height: 2.125rem;
    background-color: ${colors.charcoalGreyTwo};
    border-radius: 50%;
    position: relative;
    transition: background-color ${easingSeconds};

    &:hover {
        background-color: ${colors.brownGrey};
    }
`;

export const Socials = styled.ul`
    display: flex;
    margin-top: 1rem;

    ${SocialsItem} {
        margin-right: 0.5rem;
    }

    svg {
        position: absolute;
        width: 1.375rem;
        fill: ${colors.whiteDuplicate};
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
`;

// logo
export const HomeLink = styled(A)`
    font-size: 12px;
    line-height: 16.5px;
`;

export const NounProjectLogo = styled(NpInlineLogo)`
    width: 16.5rem;
    transition: opacity ${easingSeconds};

    &:hover {
        opacity: 0.6;
    }
`;

// text links
export const Link = styled(RouterLink)`
    text-decoration: none;

    &,
    &:any-link {
        color: ${fonts.fontColors.light.primary};

        &:hover {
            color: ${fonts.fontColors.light.link};
            text-decoration: underline;
        }
    }
`;

export const TextLink = styled.li`
    a {
        text-decoration: none;

        &,
        &:any-link {
            color: ${fonts.fontColors.light.primary};

            &:hover {
                color: ${fonts.fontColors.light.link};
                text-decoration: underline;
            }
        }
    }
`;

export const TextLinks = styled.ul`
    ${fonts.typeScale[14]};
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    @media (max-width: 75rem) {
        margin-top: -1.5rem;
    }

    ${TextLink} {
        margin-left: 1.5rem;

        @media (max-width: ${breakpoints.md}rem) {
            margin-left: 1.875rem;
            margin-top: 1.125rem;
        }
    }
`;

export const DesktopTextLinksCol = styled(Col)`
    align-self: center;
`;

export const DesktopTextLinks = styled(TextLinks)`
    margin-left: -1.5rem;

    @media (max-width: 75rem) {
        display: none;
    }
`;

export const TabletMobileTextLinks = styled(TextLinks)`
    display: none;
    margin-left: -1.5rem;

    @media (max-width: 75rem) {
        display: flex;
        margin-top: 3.4375rem;
    }

    @media (max-width: ${breakpoints.md}rem) {
        margin-top: -1.125rem;
        margin-left: -1.875rem;
    }
`;

// copyright bar
export const CopyrightBar = styled(SectionDark)`
    ${fonts.typeScale[14]};
    text-align: center;
    width: 100vw;
    background-color: #1f1f25;
    padding: 0.5rem 0 0.75rem;
`;

// layout
export const SiteFooterGrid = styled(Grid)`
    overflow-x: visible;
    padding-left: 0;
    padding-right: 0;
`;

export const SiteFooterWrapper = styled(SectionDark)`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background-color: ${colors.darkTwo};
    padding-top: 5rem;
    padding-bottom: 5rem;

    ${TextLink} {
        ${A} {
            &,
            &:active,
            &:visited {
                color: ${fonts.fontColors.light.primary};
                text-decoration: none;
            }

            &:hover {
                text-decoration: underline;
                color: ${fonts.fontColors.light.link};
            }
        }
    }

    @media (max-width: ${breakpoints.lg}rem) {
        padding-top: 3.625rem;
        padding-bottom: 3.625rem;
    }

    @media (max-width: ${breakpoints.md}rem) {
        padding-top: 3.125rem;
        padding-bottom: 3.125rem;
    }
`;

export const Footer = styled.footer`
    p {
        line-height: 16.5px;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
    }

    ${SiteFooterWrapper},
    ${CopyrightBar} {
        width: 100%;
        left: auto;
        right: auto;
        margin-left: 0;
        margin-right: 0;
    }
`;
